import script from "./jijia-introduce-content.vue?vue&type=script&lang=ts&setup=true"
export * from "./jijia-introduce-content.vue?vue&type=script&lang=ts&setup=true"

import "./jijia-introduce-content.vue?vue&type=style&index=0&id=4002a9dc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4002a9dc"]])

export default __exports__